// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"29748292","127":"42739e29","239":"924e2311","350":"76d217e3","667":"ee4bbbf5","918":"ea930369"}[chunkId] + ".chunk.js";
};